import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import {
	InputField,
} from "~/components/Forms";

function ExpenseGroupFormAddEdit({item, onHandleSubmit}) {

	const isEdit = Boolean(item?.id);

	const initialValues = {
		name: '',
	}

	const validationSchema = Yup.object().shape({
		name: Yup.string().required('Bạn chưa điền tên nhóm'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if(item?.id) {
			initialValues.name = item.name;
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, isEdit);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="name" render={({field}) => (
				<InputField label="Tên nhóm" errors={errors} {...field}/>
			)}/>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm'} loại chi phí</Button>
			</div>
		</form>
	)
}

export default ExpenseGroupFormAddEdit;
